import {defineStore} from 'pinia'
import {computed, Ref, ref} from 'vue'
import {NaviRequest} from "../api/NaviRequest";

export const useSearchStore =  defineStore('search',()=>{
	
	const search_text:Ref = ref('')
	const sub_industry_id:Ref = ref([])
	const prefecture_id:Ref = ref([])
	const listings:Ref = ref([])
	const starting_salary:Ref = ref(null)
	const hot_industry_id:Ref= ref(null);
	const target:Ref = ref(NaviRequest.TARGET_SALARY);
	const page:Ref = ref(1);
	const cacheParams:any = ref({});
	
	const params = computed(()=>{
		return getParams();
	});
	const reset = ()=>{
		search_text.value = '';
		sub_industry_id.value = [];
		prefecture_id.value = [];
		listings.value = [];
		starting_salary.value = '';
		hot_industry_id.value = '';
		target.value = NaviRequest.TARGET_SALARY;
		page.value = 1;
	}

	const init = (search_condition)=>{
		search_text.value = search_condition.search_text ?? '';
		sub_industry_id.value = search_condition.sub_industry_id ?? [];
		prefecture_id.value = search_condition.prefecture_id ?? [];
		listings.value = search_condition.listings ?? [];
		starting_salary.value = search_condition.starting_salary ?? '';
		hot_industry_id.value = '';
		target.value = NaviRequest.TARGET_SALARY;
		page.value = 1;
		cache();
	}


	const getParams = ()=>{
		
		if(starting_salary.value == null){
			starting_salary.value = '';
		}
		
		return {
			search_text:search_text.value,
			sub_industry_id:sub_industry_id.value,
			prefecture_id:prefecture_id.value,
			listings:listings.value,
			starting_salary:starting_salary.value,
			hot_industry_id:hot_industry_id.value,
			target:target.value,
			page: page.value
		}
	}
	
	
	const cache = ()=>{
		cacheParams.value = getParams();
	}
	
	const restoreCache = ()=>{
		search_text.value = cacheParams.value.search_text;
		sub_industry_id.value = cacheParams.value.sub_industry_id;
		prefecture_id.value = cacheParams.value.prefecture_id;
		listings.value = cacheParams.value.listings;
		starting_salary.value = cacheParams.value.starting_salary;
		hot_industry_id.value = cacheParams.value.hot_industry_id;
		target.value = cacheParams.value.target;
	}
	
	const clearindustry = ()=>{
		sub_industry_id.value = [];
	}
	
	const clearArea = ()=>{
		prefecture_id.value = [];
	}
	
	const hasSearchParam = ()=>{
		
		const params = getParams();
		if(params.search_text != ''){
			console.log('>>>>>>>>>0');
			return true;
		}else if(params.sub_industry_id.length > 0){
			console.log('>>>>>>>>>1');
			return true;
		}else if(params.prefecture_id.length > 0){
			console.log('>>>>>>>>>2');
			return true;
		}else if(params.listings.length > 0){
			console.log('>>>>>>>>>3');
			return true;
		}else if(params.starting_salary != ''){
			console.log('>>>>>>>>>4');
			return true;
		}else if(params.hot_industry_id != ''){
			console.log('>>>>>>>>>5');
			return true;
		}
		console.log('>>>>>>>false');
		return false;
	}
	
	return {
		reset,
		init,
		cache,
		restoreCache,
		cacheParams,
		search_text,
		sub_industry_id,
		prefecture_id,
		listings,
		starting_salary,
		hot_industry_id,
		target,
		page,
		params,
		clearindustry,
		clearArea,
		hasSearchParam
	}
})